import { Component, OnInit } from "@angular/core";
import { Constants } from '../../../constants';
@Component({
  selector: "app-admin-navbar",
  templateUrl: "./admin-navbar.component.html",
})
export class AdminNavbarComponent implements OnInit {

  username: string;
  constructor() {}

  ngOnInit(): void {
    this.username = localStorage.getItem(Constants.USER)
  }
}
